import { ActionType } from '../../actions/ActionType';
import { Action } from '../../actions/membershipReport/UpdateMemberNumberActions';

export interface UpdateMemberNumberState {
    isLoading: boolean;
    error: string | null;
    MemberInfo: {
        memberNumber: string;
        memberName: string;
    },
}

const initialState = {
    isLoading: false,
    error: null,
    MemberInfo: { memberNumber: "", memberName: "" },
};

const updateMemberNumberReducer = (
    state: UpdateMemberNumberState = initialState,
    action: Action
) => {
    switch (action.type) {
        case ActionType.FETCH_MEMBER_NAME_START:
            return {
                isLoading: true,
                error: null,
                MemberInfo: state.MemberInfo,
            };
        case ActionType.FETCH_MEMBER_NAME_SUCCESS:
            return {
                isLoading: false,
                error: null,
                MemberInfo: action.payload,
            };
        case ActionType.FETCH_MEMBER_NAME_ERROR:
            return {
                isLoading: false,
                error: action.payload,
                MemberInfo: { memberNumber: "", memberName: "" },
            };
        default:
            return state;
    }
};

export default updateMemberNumberReducer;